<template>
  <b-form-group
    label="Kira Bedeli"
    label-for="amount"
  >
    <b-input-group>
      <b-form-input
        id="amount"
        v-model="dataItem.tenants.amount"
        placeholder="Kira Bedeli"
        :disabled="editable || isDisabled"
      />
      <b-input-group-append is-text>
        TL
      </b-input-group-append>
    </b-input-group>
  </b-form-group>
</template>
<script>
import {
  BFormGroup, BInputGroupAppend, BInputGroup, BFormInput,
} from 'bootstrap-vue'
import moment from 'moment'

export default {
  name: 'TenantAmount',
  components: {
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BFormGroup,
  },
  props: {
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dataItem() {
      return this.$store.getters['estates/dataItem']
    },
    editable() {
      if (this.dataItem.tenants.created) {
        const endDate = moment(this.dataItem.tenants.created).add(30, 'day')
        const today = moment()
        return !(endDate.diff(today, 'days') > 0)
      }
      return true
    },
  },
}
</script>
